import {store} from '@components/Test/Context';
import BinaryOption from '@components/Test/Option/BinaryOption';
import PointsOption from '@components/Test/Option/PointsOption';
import {BINARY, POINTS} from '@constants/test';
import type {ReactElement} from 'react';
import {useContext} from 'react';

interface Props {
    id: number;
    questionType: string;
    value?: number;
    isCorrect?: boolean;
    content: string;
    comment?: string;
    showStats: boolean;
    hasStatsLoaded: boolean;
    isStatsLoading: boolean;
}

export default function Option(props: Props): ReactElement<Props> {
    const {currentState} = useContext(store);

    function getStatsPercentage(): number {
        if (!currentState.isChecked || !props.showStats) {
            return 0;
        }

        const total = Number(
            Object.values(currentState.stats).reduce((acc: number, item) => acc + Number(item), 1),
        );
        const current =
            currentState.selectedOption === props.id
                ? Number(currentState.stats[props.id] || 0) + 1
                : Number(currentState.stats[props.id] || 0);
        return Math.round((current / total) * 100) || 0;
    }

    return (
        <>
            {currentState.type === BINARY && (
                <BinaryOption {...props} statsPercentage={getStatsPercentage()} />
            )}
            {currentState.type === POINTS && (
                <PointsOption {...props} statsPercentage={getStatsPercentage()} />
            )}
        </>
    );
}
